import React from 'react'

const TableRow = props => (
  <tr style={{ color: props.color }} className={props.className}>
    {props.children}
  </tr>
)

export default TableRow
